import { InjectionToken } from '@angular/core';

export const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy';

export const DATE_FNS_FORMAT = new InjectionToken<string>('DATE_FNS_FORMAT');
